import { atom } from 'jotai';
import type { InterpolationManager } from '../interpolation-manager';
export const interpolationManagerAtom = atom<InterpolationManager | null>(null);